import { render } from "./TeamsList.vue?vue&type=template&id=035dda38&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"

import "./TeamsList.vue?vue&type=style&index=0&id=035dda38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035dda38"]])

export default __exports__